import React, { Component } from 'react';
import { Link } from 'react-router-dom';

import SectionHeader from 'components/shared/landing/section-header';
import { FaqContainer, FaqItem } from 'components/shared/faq-item';
import ExplainerVideo from 'assets/videos/unyted-teamwork.mp4';
import styles from './styles.module.scss';
import BlackBelt from './images/Belt-Black.svg';
import BlueBelt from './images/Belt-Blue.svg';
import BrownBelt from './images/Belt-Brown.svg';
import OrangeBelt from './images/Belt-Orange.svg';
import YellowBelt from './images/Belt-Yellow.svg';
import WhiteBelt from './images/Belt-White.svg';

class UnytedMethod extends Component {
  render() {
    return (
      <div className={styles.unytedMethod}>
        <section className={styles.header}>
          <div className="container">
            <div className="row">
              <div className="col-12 d-flex flex-column align-items-center">
                <h1>The TEAM Method&trade;</h1>
                <p>
                  The TEAM Method&trade; is a process where learners work with
                  at least one teammate (sometimes peers; sometimes with an
                  educator directly) to solve problems together. What makes it
                  unique is how the patent-pending online technology guides
                  teammates to move forward. They can only advance in consensus,
                  which encourages learners to practice and develop{' '}
                  <a href="/sel-encyclopedia">
                    key SEL Power Skills (e.g. communication, impulse control,
                    etc.)
                  </a>{' '}
                  and understand academic topics faster through their
                  discussions. It also provides unique opportunities for
                  coaching by certified Unyted educators.{' '}
                </p>
              </div>
            </div>
          </div>
        </section>
        <section className={styles.unytedRole}>
          <div className="container">
            <div className="row align-items-center">
              <div className="col-12 col-lg-5">
                <video
                  className={styles.video}
                  autoplay="true"
                  muted="true"
                  loop="true"
                  playsinline="true"
                  src={ExplainerVideo}
                />
              </div>
              <div className="col-12 col-lg-7">
                <dl className={styles.acronymList}>
                  <div className={styles.term}>
                    <dt>T</dt>
                    <div className={styles.definitions}>
                      <dd>urn any problem or issue into an opportunity.</dd>
                      <dd>
                        Unyted learners understand problems are a way to grow
                        and connect it to the real world.
                      </dd>
                    </div>
                  </div>

                  <div className={styles.term}>
                    <dt>E</dt>
                    <div className={styles.definitions}>
                      <dd>valuate all sides of the opportunity.</dd>
                      <dd>
                        We reinvented the discussion board to make this process
                        authentic, like a modern chat, but with a clear end
                        goal.
                      </dd>
                    </div>
                  </div>

                  <div className={styles.term}>
                    <dt>A</dt>
                    <div className={styles.definitions}>
                      <dd>ct to move forward together.</dd>
                      <dd>
                        Our patent-pending online technology structures problem
                        solving in a way that engages members to move forward as
                        a team.
                      </dd>
                    </div>
                  </div>

                  <div className={styles.term}>
                    <dt>M</dt>
                    <div className={styles.definitions}>
                      <dd>ake time to reflect on actions</dd>
                      <dd>
                        We collect info and feedback to guide learners during
                        and after the process.
                      </dd>
                    </div>
                  </div>
                </dl>
              </div>
            </div>
          </div>
        </section>
        <section className={styles.belts}>
          <div className="container">
            <div className="row">
              <div className="col-12">
                <h5>Levels for Each Targeted Skill</h5>
                <h2>Belts of Mastery</h2>

                <div className={styles.beltsContainer}>
                  <div className={styles.belt}>
                    <h5>White</h5>
                    <h3>Engaged</h3>
                    <img src={WhiteBelt} />
                    <p>
                      The light comes on. Learner has no previous formal
                      training in targeted skill.
                    </p>
                  </div>
                  <div className={styles.belt}>
                    <h5>Yellow</h5>
                    <h3>Motivated</h3>
                    <img src={YellowBelt} />
                    <p>
                      The light begins to spread. Learner shows openness to
                      growth on targeted skill.
                    </p>
                  </div>
                  <div className={styles.belt}>
                    <h5>Orange</h5>
                    <h3>Dedicated</h3>
                    <img src={OrangeBelt} />
                    <p>
                      The light shows consistent growth. Learner now has a
                      deeper understanding of targeted skill.{' '}
                    </p>
                  </div>
                  <div className={styles.belt}>
                    <h5>Blue</h5>
                    <h3>Connected</h3>
                    <img src={BlueBelt} />
                    <p>
                      Growth is now connected at the higher levels. Blue
                      represents the sky. Learner begins to connect skill to
                      multiple aspects of life and scenarios.
                    </p>
                  </div>
                  <div className={styles.belt}>
                    <h5>Brown</h5>
                    <h3>Leader</h3>
                    <img src={BrownBelt} />
                    <p>
                      The learner is now grounded in the skill and its
                      application becomes natural. Brown represents the deep
                      roots. Learner is ready for Mastery.
                    </p>
                  </div>
                  <div className={styles.belt}>
                    <h5>Black</h5>
                    <h3>Master</h3>
                    <img src={BlackBelt} />
                    <p>
                      {' '}
                      All of the levels are now combined to one. Learner is able
                      to apply skill in multiple scenarios and even enlighten
                      others with ability.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className={styles.realLifeConnection}>
          <div className="container">
            <div className="row">
              <div className="col-12">
                <SectionHeader
                  tagline="unyted team"
                  valueprop="Real Life Connection"
                  subtext="Using The TEAM Method&trade; helps individuals learn faster and adapt to new situations better via the real world SEL Power Skills practiced and developed. These skills are used for academic success, but also transfer over to real life situations for 'success beyond the books!'"
                />
              </div>
            </div>
          </div>
        </section>
        <section className={styles.faqs}>
          <div className="container">
            <div className="row">
              <div className="col-12">
                <h2>Frequently Asked Questions</h2>
              </div>
              <div className="col-12">
                <FaqContainer>
                  <FaqItem question="Does Unyted just teach this method or do you coach academic subjects like Math, Science, etc.?">
                    <p>
                      The TEAM Method&trade; is used with our online tools{' '}
                      <em>for</em> better and faster understanding of subjects
                      like Math, Science, etc.
                    </p>
                  </FaqItem>

                  <FaqItem question="How do you back up that learners will understand faster and better?">
                    <p>
                      Have you ever heard the philosophy "if you can't explain
                      it, you don't know it well enough?" We help accelerate
                      that process through multiple strategies. See research on{' '}
                      <a href="https://www.researchgate.net/publication/222704753_Active_learning_and_cooperative_learning_Understanding_the_difference_and_using_both_styles_effectively">
                        Active Learning
                      </a>
                      ,{' '}
                      <a href="https://ro.ecu.edu.au/cgi/viewcontent.cgi?article=2902&context=ajte">
                        Effective Cooperative Learning
                      </a>
                      ,{' '}
                      <a href="https://www.sciencedirect.com/science/article/pii/S2452301116300062">
                        Problem-Based Learning
                      </a>
                      , digital{' '}
                      <a href="http://www.nea.org/tools/16963.htm">
                        Project-Based Learning
                      </a>
                      , and{' '}
                      <a href="https://www.ncbi.nlm.nih.gov/pmc/articles/PMC5839644/">
                        Interest Based Learning
                      </a>
                      .
                    </p>
                  </FaqItem>

                  <FaqItem
                    question={
                      'How does this develop Social Emotional Skills (SEL) in learners?'
                    }
                  >
                    <p>
                      Whenever a team tries to solve a problem together,{' '}
                      <Link to="/sel-encyclopedia">SEL skills</Link> are a
                      necessary part of success. This gives Unyted educators
                      better opportunities to hone in on skill development
                      during the academic process. It also gives learners real
                      life opportunities to practices these key skills.
                    </p>
                  </FaqItem>

                  <FaqItem question="Can this be used outside of learning academic subjects?">
                    <p>
                      That's part of our mission! When learners are consistently
                      put in these scenarios, sure, they get better academic and
                      SEL development. But, the magic is that it forms habits
                      that transfer outside of the technology. An experienced
                      Unyted learner uses The TEAM Method&trade; as an instinct
                      in many future work and life scenarios!
                    </p>
                  </FaqItem>
                </FaqContainer>
              </div>
            </div>
          </div>
        </section>
      </div>
    );
  }
}

export default UnytedMethod;
